import styled from 'styled-components';

export const BackgroundOverlay = styled.div`
    background: url('Images/Main-Bg.png') no-repeat top center;
    background-size: cover;
    }
`;